import React from "react";
import { formatCrcCurrent, formatCrcHighest } from "@/lib/currentRangeCompetition";

const CRC_COLUMNS = ["Current", "Average", "Lowest", "Highest", "Competition"];

export function CurrentRangeCompetitionTable({ rows }) {
  return (
    <div className="overflow-x-auto ez-scroll" data-testid="crc-table-wrap">
      <table className="w-full text-compact" data-testid="crc-table">
        <thead>
          <tr className="text-micro font-mono uppercase text-ink-muted text-left bg-surface-2">
            <th className="py-2 px-3 sticky left-0 bg-surface-2">Metric</th>
            {CRC_COLUMNS.map((c) => (
              <th key={c} className="px-3 text-right whitespace-nowrap">{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={`${r.metric}-${i}`} className="border-b border-edge-subtle last:border-0 hover:bg-surface-2" data-testid={`crc-row-${r.metric}`}>
              <td className="py-2 px-3 text-ink-primary sticky left-0 bg-surface-0 whitespace-nowrap">
                {r.metric}
              </td>
              <td className="px-3 text-right font-mono text-ink-primary font-semibold">{formatCrcCurrent(r.current, r.unit)}</td>
              <td className="px-3 text-right font-mono text-ink-secondary">—</td>
              <td className="px-3 text-right font-mono text-ink-secondary">—</td>
              <td className="px-3 text-right font-mono text-ink-secondary" data-testid={`crc-highest-${r.metric}`}>{formatCrcHighest(r)}</td>
              <td className="px-3 text-right font-mono text-ink-secondary" data-testid={`crc-competition-${r.metric}`}>{r.competition || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="text-micro text-ink-muted mt-2 px-1">
        Average, Lowest, and Highest stay unavailable until observed history exists.
        Additional-offer starting price appears under Competition for Featured Offer price — it is not a historical high.
      </p>
    </div>
  );
}

export { CRC_COLUMNS };
